import React from "react";
import { Box, Link, Stack } from "@mui/material";
import { useIsChuseokCallOff } from "../../../hooks/useChuseokOff";

export function FullWidthTwinButton({
  backgroundColor,
  firstBtn,
  secondBtn,
}: {
  backgroundColor?: string;
  /**
   * isGoiCall: 이 버튼이 고이 대표번호로 거는 콜인지.
   * onClick 안에서 call() 을 부르는 형태라 컴포넌트가 스스로 알 수 없어 호출부가 알려준다.
   * 2026 추석에 장지, 화장장 경로에서 이 버튼만 빠지고 남은 버튼이 폭을 채운다.
   */
  firstBtn: {
    text: string;
    href?: string;
    onClick?: () => void;
    isGoiCall?: boolean;
  };
  secondBtn: {
    text: string;
    href?: string;
    onClick?: () => void;
    isGoiCall?: boolean;
  };
}) {
  const isChuseokCallOff = useIsChuseokCallOff();
  const hideFirst = Boolean(firstBtn.isGoiCall) && isChuseokCallOff;
  const hideSecond = Boolean(secondBtn.isGoiCall) && isChuseokCallOff;

  return (
    <Stack flexDirection="row" width="100%" gap="12px">
      {!hideFirst && (
      <Link
        href={firstBtn.href && firstBtn.href}
        onClick={firstBtn.onClick && firstBtn.onClick}
        style={{
          flex: 1,
          background: backgroundColor || "",
          border: backgroundColor ? "" : "1px solid #8f8f8f",
          padding: "16px",
          color: backgroundColor ? "white" : "#252525",
          borderRadius: "8px",
          textDecoration: "none",
          textAlign: "center",
        }}
      >
        <Box className="subtitle_16_b">{firstBtn.text}</Box>
      </Link>
      )}
      {!hideSecond && (
      <Link
        href={secondBtn.href && secondBtn.href}
        onClick={secondBtn.onClick && secondBtn.onClick}
        style={{
          flex: 1,
          background: backgroundColor || "",
          border: backgroundColor ? "" : "1px solid #8f8f8f",
          padding: "16px",
          color: backgroundColor ? "white" : "#252525",
          borderRadius: "8px",
          textDecoration: "none",
          textAlign: "center",
        }}
      >
        <Box className="subtitle_16_b">{secondBtn.text}</Box>
      </Link>
      )}
    </Stack>
  );
}
